import { DatePipe } from '@angular/common';
import { Component, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, interval, timer } from 'rxjs';
import {
  // 取得API
  DASHBOARD_MEMBER,
  DASHBOARD_SUMMARY1,
  DASHBOARD_MEMBER2,
  DASHBOARD_USER,
  DASHBOARD_LOGIN_MEMBER,
  DASHBOARD_LOGIN_USER,
  DASHBOARD_AGENDA_SOLUTION,
  DASHBOARD_SUMMARY2,
  DASHBOARD_AGENDA_SOLUTION_2,
  DASHBOARD_SUGGEST,
  DASHBOARD_OPINION_EXCHANGE,
  DASHBOARD_COOP,
  // CSV出力API
  DASHBOARD_MEMBER_CSV,
  DASHBOARD_MEMBER_CSV_USE_STATEMACHINE,
  DASHBOARD_PWD_SETTING_U_CSV,
  DASHBOARD_PWD_SETTING_U_CSV_USE_STATEMACHINE,
  DASHBOARD_PWD_SETTING_UU_CSV,
  DASHBOARD_PWD_SETTING_UU_CSV_USE_STATEMACHINE,
  DASHBOARD_MONTH_LOGIN_U_CSV,
  DASHBOARD_MONTH_LOGIN_U_CSV_USE_STATEMACHINE,
  DASHBOARD_MONTH_LOGIN_UU_CSV,
  DASHBOARD_MONTH_LOGIN_UU_CSV_USE_STATEMACHINE,
  DASHBOARD_AGENDA_REGIST_ORGANIZATION_CSV,
  DASHBOARD_AGENDA_REGIST_ORGANIZATION_CSV_USE_STATEMACHINE,
  DASHBOARD_AGENDA_REGIST_CSV,
  DASHBOARD_AGENDA_REGIST_CSV_USE_STATEMACHINE,
  DASHBOARD_SOLUTION_REGIST_CSV,
  DASHBOARD_SOLUTION_REGIST_CSV_USE_STATEMACHINE,
  DASHBOARD_SUGGEST_REGIST_CSV,
  DASHBOARD_SUGGEST_REGIST_CSV_USE_STATEMACHINE,
  DASHBOARD_OPINION_EXCHANGE_CSV,
  DASHBOARD_OPINION_EXCHANGE_CSV_USE_STATEMACHINE,
  DASHBOARD_COOPERATION_START_CSV,
  DASHBOARD_COOPERATION_START_CSV_USE_STATEMACHINE,
  DASHBOARD_MEMBER_SUMCSV,
  DASHBOARD_PWD_SETTING_U_SUMCSV,
  DASHBOARD_PWD_SETTING_UU_SUMCSV,
  DASHBOARD_MONTH_LOGIN_U_SUMCSV,
  DASHBOARD_MONTH_LOGIN_UU_SUMCSV,
  DASHBOARD_AGENDA_REGIST_ORGANIZATION_SUMCSV,
  DASHBOARD_AGENDA_REGIST_SUMCSV,
  DASHBOARD_SOLUTION_REGIST_SUMCSV,
  DASHBOARD_SUGGEST_REGIST_SUMCSV,
  DASHBOARD_OPINION_EXCHANGE_SUMCSV,
  DASHBOARD_COOPERATION_START_SUMCSV,
  // S3データ読込
  DASHBOARD_READ_JSON_FROM_S3,
  // ステートマシンのARN
  DASHBOARD_MEMBER_CSV_STATEMACHINEARN,
  DASHBOARD_PWD_SETTING_U_CSV_STATEMACHINE,
  DASHBOARD_PWD_SETTING_UU_CSV_STATEMACHINE,
  DASHBOARD_MONTH_LOGIN_U_CSV_STATEMACHINE,
  DASHBOARD_MONTH_LOGIN_UU_CSV_STATEMACHINE,
  DASHBOARD_AGENDA_REGIST_ORGANIZATION_CSV_STATEMACHINE,
  DASHBOARD_AGENDA_REGIST_CSV_STATEMACHINEARN,
  DASHBOARD_SOLUTION_REGIST_CSV_STATEMACHINEARN,
  DASHBOARD_SUGGEST_REGIST_CSV_STATEMACHINEARN,
  DASHBOARD_OPINION_EXCHANGE_CSV_STATEMACHINEARN,
  DASHBOARD_COOPERATION_START_CSV_STATEMACHINEARN,
  API_URL_RUN_COUNT,

} from 'manager/http-constants';
import { CONSTANT, DATE_FORMAT } from 'src/app/shared/constant/constant';
import { DASHBOARD_CONSTANT } from './constant';
import { DASHBOARD_TEMPLATE } from 'manager/template-constant';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../platform.component';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { ExportFileService, fileInformation } from 'src/app/shared/html-parts/export-file/export-file.service';
import { HttpClient, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-i101',
  templateUrl: './i101.component.html',
  styleUrls: ['./i101.component.scss', '../platform.component.scss'],
})

/**
 * ダッシュボード
 */
export class I101Component extends PlatformComponent {
  // 画面.検索フォーム
  i101SearchFormMember: FormGroup = this.formBuilder.group({
    // 掲載開始日(FROM)
    date1: CONSTANT.EMPTY_STRING,
    // 掲載終了日(TO)
    date2: CONSTANT.EMPTY_STRING,
  });
  // 画面.検索フォーム
  i101SearchFormMatching: FormGroup = this.formBuilder.group({
    // 掲載開始日(FROM)
    date1: CONSTANT.EMPTY_STRING,
    // 掲載終了日(TO)
    date2: CONSTANT.EMPTY_STRING,
  });

  // ダッシュボード表示リスト結果格納先
  memberDataList: object[] = new Array();
  summary1DataList: object[] = new Array();
  member2DataList: object[] = new Array();
  userDataList: object[] = new Array();
  agendaSolutionDataList: object[] = new Array();
  loginMemberDataList: object[] = new Array();
  loginUserDataList: object[] = new Array();
  summary2DataList: object[] = new Array();
  solutionDataList: object[] = new Array();
  agendaDataList: object[] = new Array();
  suggestDataList: object[] = new Array();
  opinionExchangeDataList: object[] = new Array();
  coopDataList: object[] = new Array();

  // 会員数
  memberCountDataList: any;

  // ID/PWD設定済U団体数
  pwdSettingCompleteUDataList: any;

  // ID/PWD設定済UU数
  pwdSettingCompleteUUDataList: any;

  // 月間ログインU団体数
  monthLoginOrganizationUDataList: any;

  // 月間ログインUU数
  monthLoginOrganizationUUDataList: any;

  // 課題登録団体数(累計)
  agendaRegistOganizationCountDataList: any;

  // 課題登録件数
  agendaRegistCountDataList: any;

  // ソリューション登録件数
  solutionRegistCountDataList: any;

  // 提案登録件数
  suggestRegistCountDataList: any;

  // 意見交換希望件数
  opinionExchangeDesiredCountDataList: any;

  // 連携開始件数
  coordinationStartCountDataList: any;

  // 会員分析タグ表示チャートオプション
  memberChartOptions = {
    responsive: true,
    scales: {
      yAxes: [{
        ticks: { beginAtZero: true },
        stacked: true
      }],
      xAxes: [{
        scaleLabel: {
          display: true,
          labelString: '月'
        },
        ticks: { beginAtZero: true },
        stacked: true
      }]
    },
    plugins: {
      filler: {
        propagate: true
      }
    },
    legend: {
      position: 'bottom'
    }
  };

  // マッチングボトルネック分析タグ表示チャートオプション
  matchingChartOptions = {
    responsive: true,
    scales: {
      yAxes: [{
        ticks: { beginAtZero: true },
        stacked: true
      }],
      xAxes: [{
        scaleLabel: {
          display: true,
          labelString: '月'
        },
        ticks: { beginAtZero: true },
        stacked: true
      }]
    },
    plugins: {
      filler: {
        propagate: true
      }
    },
    legend: {
      display: true,
      position: 'bottom',
      reverse: true
    }
  };

  // セッション保存名
  sessionTagName: string = 'i101Conditions';

  static i101SearchFormMember: any;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private messageData: MessageData,
    private exportFileService: ExportFileService,
  ) {
    super(route, commonService, dbOperationService, loadingState);
  }

  ngOnInit(): void {
    // 初期値設定
    if (sessionStorage.getItem(this.sessionTagName) == undefined) {
      this.initParamSetting();
    } else {
      //記録条件の読み込み＆画面セット
      let s = sessionStorage.getItem(this.sessionTagName);
      let sp = s.split(",")
      this.i101SearchFormMember.setValue({ date1: sp[0], date2: sp[1] });
      this.i101SearchFormMatching.setValue({ date1: sp[0], date2: sp[1] });
    }

    // 辞書値リストを取得
    this.getSpecCodeList(1004);

    // ダッシュボード表示リスト結果を取得
    this.getResultDataList();


  }



  /**
   * ダッシュボード表示リスト結果を取得
   */
  private initParamSetting() {
    // 変数宣言 fromDate = 当日の年度始めを設定
    let today = new Date();
    let yesterday = today.setDate(today.getDate() - 1);
    let currentYear = new Date();
    currentYear.setMonth(currentYear.getMonth() - 3);

    let fromDate = new Date(currentYear.getFullYear(), 3, 1);

    // 検索値を初期設定
    this.i101SearchFormMember.setValue({
      date1: this.datePipe.transform(fromDate, DATE_FORMAT.DATE_SLASH),
      date2: this.datePipe.transform(yesterday, DATE_FORMAT.DATE_SLASH)
    });
    this.i101SearchFormMatching.setValue({
      date1: this.datePipe.transform(fromDate, DATE_FORMAT.DATE_SLASH),
      date2: this.datePipe.transform(yesterday, DATE_FORMAT.DATE_SLASH)
    });
  }

  /**
   * 検索処理実行判定
   */
  private checkSearchDate(): boolean {
    // 検索期間が入力されているか確認
    if (this.i101SearchFormMember.get('date1').value == null ||
      this.i101SearchFormMember.get('date2').value == null) {
      // 拡張子エラーメッセージ
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.ERROR,
          summary: this.commonService.msg(MESSAGE_CODE.E00032),
          detail: this.commonService.msg(MESSAGE_CODE.E00020),
        })
      );
      return false;
    }

    // 検索期間が最小1日、最大13か月を超えているか確認
    // 各判定用の日付を定義
    // 検索条件に入力されたfrom, to
    let fromDate = new Date(this.i101SearchFormMember.get('date1').value);
    let toDate = new Date(this.i101SearchFormMember.get('date2').value);
    // from, toの差分(日)
    let diffDate = (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24);
    // toの13か月前
    let before13MonthsDate = new Date(this.i101SearchFormMember.get('date2').value);
    before13MonthsDate.setMonth(before13MonthsDate.getMonth() - 13);

    // 判定
    if (diffDate < 1 || fromDate.getTime() < before13MonthsDate.getTime()) {
      // 拡張子エラーメッセージ
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.ERROR,
          summary: this.commonService.msg(MESSAGE_CODE.E00032),
          detail: this.commonService.msg(MESSAGE_CODE.E00033),
        })
      );
      return false;
    }

    return true
  }

  /**
   * ダッシュボード表示リスト結果を取得
   */
  public getResultDataList(type?: string): void {

    // 検索条件を設定する
    let searchForm;
    if (type != "matching") {
      searchForm = this.i101SearchFormMember.value;
      this.i101SearchFormMatching.setValue(this.i101SearchFormMember.value);
    } else {
      searchForm = this.i101SearchFormMatching.value;
      this.i101SearchFormMember.setValue(this.i101SearchFormMatching.value);
    }

    // 検索可能か判定する
    if (!this.checkSearchDate()) return;

    // 条件保存
    this.saveConditions();

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(DASHBOARD_SUMMARY1);
    this.loadingState.loadStart(DASHBOARD_MEMBER);
    this.loadingState.loadStart(DASHBOARD_MEMBER2);
    this.loadingState.loadStart(DASHBOARD_USER);
    this.loadingState.loadStart(DASHBOARD_LOGIN_MEMBER);
    this.loadingState.loadStart(DASHBOARD_LOGIN_USER);
    this.loadingState.loadStart(DASHBOARD_AGENDA_SOLUTION);
    this.loadingState.loadStart(DASHBOARD_SUMMARY2);
    this.loadingState.loadStart(DASHBOARD_AGENDA_SOLUTION + "_solution");
    this.loadingState.loadStart(DASHBOARD_AGENDA_SOLUTION + "_agenda");
    this.loadingState.loadStart(DASHBOARD_SUGGEST);
    this.loadingState.loadStart(DASHBOARD_OPINION_EXCHANGE);
    this.loadingState.loadStart(DASHBOARD_COOP);

    // ダッシュボード サマリー1を取得
    this.dbOperationService
      .getNoTemplateData(DASHBOARD_SUMMARY1, searchForm, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.summary1DataList = response.body;
          // alert("summary1: " + JSON.stringify(this.summary1DataList));
        } else {
          this.summary1DataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, DASHBOARD_SUMMARY1);
      });

    // ダッシュボード(会員：会員数)を取得
    this.dbOperationService
      .getNoTemplateData(DASHBOARD_MEMBER, searchForm, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.memberDataList = response.body;
          // alert("member: " + JSON.stringify(this.memberDataList));
          this.memberCountDataList = this.setChartData(
            this.memberDataList,
            "line"
          );
        } else {
          this.memberDataList = new Array();
          this.memberCountDataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, DASHBOARD_MEMBER);
      });

    // ダッシュボード（会員）：ID/PWD設定済U団体数
    this.dbOperationService
      .getNoTemplateData(DASHBOARD_MEMBER2, searchForm, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.member2DataList = response.body;
          // alert("member2: " + JSON.stringify(this.member2DataList));

          this.pwdSettingCompleteUDataList = this.setChartData(
            this.member2DataList,
            "line"
          );
        } else {
          this.member2DataList = new Array();
          this.pwdSettingCompleteUDataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, DASHBOARD_MEMBER2);
      });

    // ダッシュボード（会員）：ID/PWD設定済UU数 を取得
    this.dbOperationService
      .getNoTemplateData(DASHBOARD_USER, searchForm, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.userDataList = response.body;
          // alert("user: " + JSON.stringify(this.userDataList));

          this.pwdSettingCompleteUUDataList = this.setChartData(
            this.userDataList,
            "line"
          );
        } else {
          this.userDataList = new Array();
          this.pwdSettingCompleteUUDataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, DASHBOARD_USER);
      });

    // ダッシュボード（会員）：月間ログインU団体数 を取得
    this.dbOperationService
      .getNoTemplateData(DASHBOARD_LOGIN_MEMBER, searchForm, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.loginMemberDataList = response.body;
          // alert("login_member: " + JSON.stringify(this.loginMemberDataList));

          this.monthLoginOrganizationUDataList = this.setChartData(
            this.loginMemberDataList,
            "bar"
          );
        } else {
          this.loginMemberDataList = new Array();
          this.monthLoginOrganizationUDataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, DASHBOARD_LOGIN_MEMBER);
      });

    // ダッシュボード（会員）：月間ログインUU数 を取得
    this.dbOperationService
      .getNoTemplateData(DASHBOARD_LOGIN_USER, searchForm, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.loginUserDataList = response.body;
          // alert("login_user: " + JSON.stringify(this.loginUserDataList));

          this.monthLoginOrganizationUUDataList = this.setChartData(
            this.loginUserDataList,
            "bar"
          );
        } else {
          this.loginUserDataList = new Array();
          this.monthLoginOrganizationUUDataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, DASHBOARD_LOGIN_USER);
      });

    // ダッシュボード（会員）：課題登録団体数（累計）
    this.dbOperationService
      .getNoTemplateData(DASHBOARD_AGENDA_SOLUTION, searchForm, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.agendaSolutionDataList = response.body;
          // alert("agenda_solution: " + JSON.stringify(this.agendaSolutionDataList));

          this.agendaRegistOganizationCountDataList = this.setChartData(
            this.agendaSolutionDataList,
            "bar"
          );
        } else {
          this.agendaSolutionDataList = new Array();
          this.agendaRegistOganizationCountDataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, DASHBOARD_AGENDA_SOLUTION);
      });

    // ダッシュボード（マッチング）：Summary
    this.dbOperationService
      .getNoTemplateData(DASHBOARD_SUMMARY2, searchForm, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.summary2DataList = response.body;
          // alert("summary2: " + JSON.stringify(this.summary2DataList));

        } else {
          this.summary2DataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, DASHBOARD_SUMMARY2);
      });

    // ダッシュボード（マッチング）：課題登録件数用に検索条件を修正
    let searchFormMatchingAgenda = {
      date1: this.i101SearchFormMember.get('date1').value,
      date2: this.i101SearchFormMember.get('date2').value,
      agenda_kbn: 1,
    };

    // ダッシュボード（マッチング）：課題・ソリューション登録件数(課題)
    this.dbOperationService
      .getNoTemplateData(DASHBOARD_AGENDA_SOLUTION_2, searchFormMatchingAgenda, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.agendaDataList = response.body;
          // alert("agenda: " + JSON.stringify(this.agendaDataList));

          this.agendaRegistCountDataList = this.setChartComboData(
            this.agendaDataList
          );
        } else {
          this.agendaDataList = new Array();
          this.agendaRegistCountDataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, DASHBOARD_AGENDA_SOLUTION + "_agenda");
      });

    // ダッシュボード（マッチング）：課題・ソリューション登録件数用に検索条件を修正
    let searchFormMatchingSolution = {
      date1: this.i101SearchFormMember.get('date1').value,
      date2: this.i101SearchFormMember.get('date2').value,
      agenda_kbn: 2,
    };
    // ダッシュボード（マッチング）：課題・ソリューション登録件数(ソリューション)
    this.dbOperationService
      .getNoTemplateData(DASHBOARD_AGENDA_SOLUTION_2, searchFormMatchingSolution, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.solutionDataList = response.body;
          // alert("solution: " + JSON.stringify(this.solutionDataList));

          this.solutionRegistCountDataList = this.setChartComboData(
            this.solutionDataList
          );
        } else {
          this.solutionDataList = new Array();
          this.solutionRegistCountDataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, DASHBOARD_AGENDA_SOLUTION + "_solution");
      });

    // ダッシュボード（マッチング）：提案登録件数
    this.dbOperationService
      .getNoTemplateData(DASHBOARD_SUGGEST, searchForm, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.suggestDataList = response.body;
          // alert("suggest: " + JSON.stringify(this.suggestDataList));

          this.suggestRegistCountDataList = this.setChartComboData(
            this.suggestDataList
          );
        } else {
          this.suggestDataList = new Array();
          this.suggestRegistCountDataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, DASHBOARD_SUGGEST);
      });

    // ダッシュボード（マッチング）：意見交換希望件数
    this.dbOperationService
      .getNoTemplateData(DASHBOARD_OPINION_EXCHANGE, searchForm, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.opinionExchangeDataList = response.body;
          // alert("opinionExchange: " + JSON.stringify(this.opinionExchangeDataList));

          this.opinionExchangeDesiredCountDataList = this.setChartComboData(
            this.opinionExchangeDataList
          );
        } else {
          this.opinionExchangeDataList = new Array();
          this.opinionExchangeDesiredCountDataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, DASHBOARD_OPINION_EXCHANGE);
      });

    // ダッシュボード（マッチング）：連携開始件数
    this.dbOperationService
      .getNoTemplateData(DASHBOARD_COOP, searchForm, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.coopDataList = response.body;
          // alert("coop: " + JSON.stringify(this.coopDataList));

          this.coordinationStartCountDataList = this.setChartComboData(
            this.coopDataList
          );
        } else {
          this.coopDataList = new Array();
          this.coordinationStartCountDataList = new Array();
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, DASHBOARD_COOP);
      });
  }

  public getBindValue(dataList: any, num1: number, str1: string, num2: number, str2: string) {
    if (dataList.length != 0) {
      if (typeof dataList[num1][str1][num2] !== 'undefined') {
        //dataListからstr2の値を探し返す
        let result = "";
        dataList[num1][str1].forEach((e: object) => {
          const arr = Object.keys(e);
          arr.forEach((e2: string) => {
            if (e2 == str2) {
              result = String(e[e2]);
            }
          });
        });
        return result;
      } else {
        return "";
      }
    } else {
      return "";
    }
  }

  /**
   * まとめてZIP出力
   */
  public exportZIPtest() {
    // csvファイル名の設定
    const fileName = "csv_zip_test";

    // // CSVファイル出力
    // this.exportFileService.exportCsv(
    //   fileName,
    //   this.subCommittieeHeader,
    //   this.subcommitteeMemberDownloadList,
    //   false
    // );

    let subcommitteeMemberDownloadList1 = new Array();
    let subcommitteeMemberDownloadList2 = new Array();
    let subcommitteeMemberDownloadList3 = new Array();
    let subcommitteeMemberDownload1 = new Array();
    subcommitteeMemberDownload1["user"] = "test1";
    subcommitteeMemberDownload1["organization_name"] = "test1";
    subcommitteeMemberDownload1["want"] = "test1";
    subcommitteeMemberDownload1["member_kbn"] = "test1";
    subcommitteeMemberDownload1["email"] = "test1";
    let subcommitteeMemberDownload2 = new Array();
    subcommitteeMemberDownload2["user"] = "test2";
    subcommitteeMemberDownload2["organization_name"] = "test2";
    subcommitteeMemberDownload2["want"] = "test2";
    subcommitteeMemberDownload2["member_kbn"] = "test2";
    subcommitteeMemberDownload2["email"] = "test2";
    let subcommitteeMemberDownload3 = new Array();
    subcommitteeMemberDownload3["user"] = "test3";
    subcommitteeMemberDownload3["organization_name"] = "test3";
    subcommitteeMemberDownload3["want"] = "test3";
    subcommitteeMemberDownload3["member_kbn"] = "test3";
    subcommitteeMemberDownload3["email"] = "test3";

    subcommitteeMemberDownloadList1.push(subcommitteeMemberDownload1);
    subcommitteeMemberDownloadList2.push(subcommitteeMemberDownload1);
    subcommitteeMemberDownloadList2.push(subcommitteeMemberDownload2);
    subcommitteeMemberDownloadList3.push(subcommitteeMemberDownload1);
    subcommitteeMemberDownloadList3.push(subcommitteeMemberDownload2);
    subcommitteeMemberDownloadList3.push(subcommitteeMemberDownload3);

    // CSVファイル出力
    const fileInformation1: fileInformation =
      this.exportFileService.exportCsv(
        fileName + 1,
        this.subCommittieeHeader,
        subcommitteeMemberDownloadList1,
        false,
        true
      );
    const fileInformation2: fileInformation =
      this.exportFileService.exportCsv(
        fileName + 2,
        this.subCommittieeHeader,
        subcommitteeMemberDownloadList2,
        false,
        true
      );
    const fileInformation3: fileInformation =
      this.exportFileService.exportCsv(
        fileName + 3,
        this.subCommittieeHeader,
        subcommitteeMemberDownloadList3,
        false,
        true
      );

    this.exportFileService.zipFileDownload(
      fileName,
      fileInformation1,
      fileInformation2,
      fileInformation3
    );
  }
  // ダウンロード用分科会参加メンバーヘッダ
  subCommittieeHeader: object[] = [
    { field: 'user', header: '氏名' },
    { field: 'organization_name', header: '団体名称' },
    { field: 'want', header: '本プラットフォームにおける活動で実現したいこと' },
    { field: 'member_kbn', header: 'メンバー区分' },
    { field: 'email', header: 'メールアドレス' }
  ];



  /**
   * 明細CSV ZIP出力
   * 引数　0=会員分析, 1=マッチングボトルネック分析
   */
  public exportZIP(flag: Number) {

    // csvファイル名の設定
    let fileName: string = "";
    if (flag === 0) {
      // 画面ロードフラグをON(ロード中状態)
      this.loadingState.loadStart(DASHBOARD_MEMBER_CSV);
      fileName = DASHBOARD_CONSTANT.MEMBER_SUMMARY_ZIP_FILENAME;
    }
    else if (flag === 1) {
      // 画面ロードフラグをON(ロード中状態)
      this.loadingState.loadStart(DASHBOARD_AGENDA_SOLUTION_2);
      fileName = DASHBOARD_CONSTANT.MATCHING_SUMMARY_ZIP_FILENAME;
    }

    //ファイル情報のリスト
    let filelist: Array<fileInformation> = []

    // 出力範囲を指定
    let searchItems = {
      summary_date_FROM: this.i101SearchFormMember.get('date1').value,
      summary_date_TO: this.i101SearchFormMember.get('date2').value,
    };
    // ファイル名、templateIdの振り分け
    let tempfileName, tempTemplateId, tempEndPoint, tempTable, stateMachineArn, RunCountRes;

    // CSVファイル出力
    if (flag === 0) {

      let member_rc, pwdSettingCompleteU_rc, pwdSettingCompleteUU_rc, monthLoginOrganizationU_rc, monthLoginOrganizationUU_rc, agendaRegistOrganization_rc: HttpResponse<any>;
      //RunCount取得
      const get = (
        tempTable,
        tempTemplateId,
        searchItems
      ) => {
        return new Promise<HttpResponse<any>>((resolve) => {
          this.dbOperationService
            .getRunCount(
              tempTable,
              tempTemplateId,
              searchItems
            ).subscribe((value) => {
              resolve(value);
            })
        });
      }

      //RunCount取得まで待機
      async function fn(searchConditions: any) {
        //直列処理
        member_rc = await get(
          DASHBOARD_CONSTANT.MEMBER_COUNT_CSV_TABLE,
          DASHBOARD_TEMPLATE.MEMBER_COUNT_CSV_TEMPLATE_ID,
          searchConditions
        );
        pwdSettingCompleteU_rc = await get(
          DASHBOARD_CONSTANT.PWD_SETTING_U_CSV_TABLE,
          DASHBOARD_TEMPLATE.PWD_SETTING_U_CSV_TEMPLATE_ID,
          searchConditions
        );
        pwdSettingCompleteUU_rc = await get(
          DASHBOARD_CONSTANT.PWD_SETTING_UU_CSV_TABLE,
          DASHBOARD_TEMPLATE.PWD_SETTING_UU_CSV_TEMPLATE_ID,
          searchConditions
        );
        monthLoginOrganizationU_rc = await get(
          DASHBOARD_CONSTANT.MONTH_LOGIN_U_CSV_TABLE,
          DASHBOARD_TEMPLATE.MONTH_LOGIN_U_CSV_TEMPLATE_ID,
          searchConditions
        );
        monthLoginOrganizationUU_rc = await get(
          DASHBOARD_CONSTANT.MONTH_LOGIN_UU_CSV_TABLE,
          DASHBOARD_TEMPLATE.MONTH_LOGIN_UU_CSV_TEMPLATE_ID,
          searchConditions
        );
        agendaRegistOrganization_rc = await get(
          DASHBOARD_CONSTANT.AGENDA_REGIST_ORGANIZATION_CSV_TABLE,
          DASHBOARD_TEMPLATE.AGENDA_REGIST_ORGANIZATION_CSV_TEMPLATE_ID,
          searchConditions
        );
        return ('ok');
      }


      //RunCount取得後にCSV出力
      fn(searchItems).then(() => {
        // CSVファイル出力

        // ダッシュボード（会員）：会員数のCSV
        const member_count = new Promise(async (resolve) => {
          tempfileName = DASHBOARD_CONSTANT.MEMBER_COUNT_CSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
          tempEndPoint = DASHBOARD_MEMBER_CSV_USE_STATEMACHINE;
          tempTemplateId = DASHBOARD_TEMPLATE.MEMBER_COUNT_CSV_TEMPLATE_ID;
          tempTable = DASHBOARD_CONSTANT.MEMBER_COUNT_CSV_TABLE;
          stateMachineArn = DASHBOARD_MEMBER_CSV_STATEMACHINEARN;
          RunCountRes = member_rc;

          this.exportFileService.exportTemplateCsv_StepFunc(
            tempfileName,
            tempTable,
            tempEndPoint,
            tempTemplateId,
            DASHBOARD_READ_JSON_FROM_S3,
            stateMachineArn,
            RunCountRes,
            searchItems,
            false,
            true
          ).subscribe(fileInformation => {
            filelist.push(fileInformation)
            resolve("ok")
          });
        })
        // ダッシュボード（会員）：ID/PWD設定済U団体数のCSV
        const pwdSettingCompleteU_count = new Promise(async (resolve) => {
          tempfileName = DASHBOARD_CONSTANT.PWD_SETTING_U_CSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
          tempEndPoint = DASHBOARD_PWD_SETTING_U_CSV_USE_STATEMACHINE;
          tempTemplateId = DASHBOARD_TEMPLATE.PWD_SETTING_U_CSV_TEMPLATE_ID;
          tempTable = DASHBOARD_CONSTANT.PWD_SETTING_U_CSV_TABLE;
          stateMachineArn = DASHBOARD_PWD_SETTING_U_CSV_STATEMACHINE;
          RunCountRes = pwdSettingCompleteU_rc;

          this.exportFileService.exportTemplateCsv_StepFunc(
            tempfileName,
            tempTable,
            tempEndPoint,
            tempTemplateId,
            DASHBOARD_READ_JSON_FROM_S3,
            stateMachineArn,
            RunCountRes,
            searchItems,
            false,
            true
          ).subscribe(fileInformation => {
            filelist.push(fileInformation)
            resolve("ok")
          });
        })
        // ダッシュボード（会員）：ID/PWD設定済UU数のCSV
        const pwdSettingCompleteUU_count = new Promise(async (resolve) => {
          tempfileName = DASHBOARD_CONSTANT.PWD_SETTING_UU_CSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
          tempEndPoint = DASHBOARD_PWD_SETTING_UU_CSV_USE_STATEMACHINE;
          tempTemplateId = DASHBOARD_TEMPLATE.PWD_SETTING_UU_CSV_TEMPLATE_ID;
          tempTable = DASHBOARD_CONSTANT.PWD_SETTING_UU_CSV_TABLE;
          stateMachineArn = DASHBOARD_PWD_SETTING_UU_CSV_STATEMACHINE;
          RunCountRes = pwdSettingCompleteUU_rc;

          this.exportFileService.exportTemplateCsv_StepFunc(
            tempfileName,
            tempTable,
            tempEndPoint,
            tempTemplateId,
            DASHBOARD_READ_JSON_FROM_S3,
            stateMachineArn,
            RunCountRes,
            searchItems,
            false,
            true
          ).subscribe(fileInformation => {
            filelist.push(fileInformation)
            resolve("ok")
          });
        })
        // ダッシュボード（会員）：月間ログインU団体数のCSV
        const monthLoginOrganizationU_count = new Promise(async (resolve) => {
          tempfileName = DASHBOARD_CONSTANT.MONTH_LOGIN_U_CSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
          tempEndPoint = DASHBOARD_MONTH_LOGIN_U_CSV_USE_STATEMACHINE;
          tempTemplateId = DASHBOARD_TEMPLATE.MONTH_LOGIN_U_CSV_TEMPLATE_ID;
          tempTable = DASHBOARD_CONSTANT.MONTH_LOGIN_U_CSV_TABLE;
          stateMachineArn = DASHBOARD_MONTH_LOGIN_U_CSV_STATEMACHINE;
          RunCountRes = monthLoginOrganizationU_rc;

          this.exportFileService.exportTemplateCsv_StepFunc(
            tempfileName,
            tempTable,
            tempEndPoint,
            tempTemplateId,
            DASHBOARD_READ_JSON_FROM_S3,
            stateMachineArn,
            RunCountRes,
            searchItems,
            false,
            true
          ).subscribe(fileInformation => {
            filelist.push(fileInformation)
            resolve("ok")
          });
        })
        // ダッシュボード（会員）：月間ログインUU数のCSV
        const monthLoginOrganizationUU_count = new Promise(async (resolve) => {
          tempfileName = DASHBOARD_CONSTANT.MONTH_LOGIN_UU_CSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
          tempEndPoint = DASHBOARD_MONTH_LOGIN_UU_CSV_USE_STATEMACHINE;
          tempTemplateId = DASHBOARD_TEMPLATE.MONTH_LOGIN_UU_CSV_TEMPLATE_ID;
          tempTable = DASHBOARD_CONSTANT.MONTH_LOGIN_UU_CSV_TABLE;
          stateMachineArn = DASHBOARD_MONTH_LOGIN_UU_CSV_STATEMACHINE;
          RunCountRes = monthLoginOrganizationUU_rc;

          this.exportFileService.exportTemplateCsv_StepFunc(
            tempfileName,
            tempTable,
            tempEndPoint,
            tempTemplateId,
            DASHBOARD_READ_JSON_FROM_S3,
            stateMachineArn,
            RunCountRes,
            searchItems,
            false,
            true
          ).subscribe(fileInformation => {
            filelist.push(fileInformation)
            resolve("ok")
          });
        })
        // ダッシュボード（会員）：課題登録団体数（累計）のCSV
        const agendaRegistOrganization_count = new Promise(async (resolve) => {
          tempfileName = DASHBOARD_CONSTANT.AGENDA_REGIST_ORGANIZATION_CSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
          tempEndPoint = DASHBOARD_AGENDA_REGIST_ORGANIZATION_CSV_USE_STATEMACHINE;
          tempTemplateId = DASHBOARD_TEMPLATE.AGENDA_REGIST_ORGANIZATION_CSV_TEMPLATE_ID;
          tempTable = DASHBOARD_CONSTANT.AGENDA_REGIST_ORGANIZATION_CSV_TABLE;
          stateMachineArn = DASHBOARD_AGENDA_REGIST_ORGANIZATION_CSV_STATEMACHINE;
          RunCountRes = agendaRegistOrganization_rc;

          this.exportFileService.exportTemplateCsv_StepFunc(
            tempfileName,
            tempTable,
            tempEndPoint,
            tempTemplateId,
            DASHBOARD_READ_JSON_FROM_S3,
            stateMachineArn,
            RunCountRes,
            searchItems,
            false,
            true
          ).subscribe(fileInformation => {
            filelist.push(fileInformation)
            resolve("ok")
          });
        })

        //全てのCSV生成後ZIP化
        Promise.all([
          member_count,
          pwdSettingCompleteU_count,
          pwdSettingCompleteUU_count,
          monthLoginOrganizationU_count,
          monthLoginOrganizationUU_count,
          agendaRegistOrganization_count
        ]).then(
          () => {
            this.exportFileService.zipFileDownload(
              fileName,
              ...filelist
            );
            // 画面ロードフラグをOFF(ロード終了)
            this.loadingState.loadSleepEnd(0.3, DASHBOARD_MEMBER_CSV);

          }
        )
      });

    }
    else if (flag === 1) {
      let agendaRegist_rc, solutionRegist_rc, suggestRegist_rc, opinionExchange_rc, cooperation_start_rc: HttpResponse<any>;
      
      //RunCount取得
      const get = (
        tempTable,
        tempTemplateId,
        searchItems
      ) => {
        return new Promise<HttpResponse<any>>((resolve) => {
          this.dbOperationService
            .getRunCount(
              tempTable,
              tempTemplateId,
              searchItems
            ).subscribe((value) => {
              resolve(value);
            })
        });
      }

      //RunCount取得まで待機
      async function fn(searchConditions: any) {

        //検索条件準備
        let searchConditions_age = {
          ...searchItems,
          agenda_kbn: 1,
        };
        let searchConditions_sol = {
          ...searchItems,
          agenda_kbn: 2,
        };
        //直列処理
        agendaRegist_rc = await get(
          DASHBOARD_CONSTANT.AGENDA_REGIST_CSV_TABLE,
          DASHBOARD_TEMPLATE.AGENDA_REGIST_CSV_TEMPLATE_ID,
          searchConditions_age
        );
        solutionRegist_rc = await get(
          DASHBOARD_CONSTANT.SOLUTION_REGIST_CSV_TABLE,
          DASHBOARD_TEMPLATE.SOLUTION_REGIST_CSV_TEMPLATE_ID,
          searchConditions_sol
        );
        suggestRegist_rc = await get(
          DASHBOARD_CONSTANT.SUGGEST_REGIST_CSV_TABLE,
          DASHBOARD_TEMPLATE.SUGGEST_REGIST_CSV_TEMPLATE_ID,
          searchConditions
        );
        opinionExchange_rc = await get(
          DASHBOARD_CONSTANT.OPINION_EXCHANGE_CSV_TABLE,
          DASHBOARD_TEMPLATE.OPINION_EXCHANGE_CSV_TEMPLATE_ID,
          searchConditions
        );
        cooperation_start_rc = await get(
          DASHBOARD_CONSTANT.COOPERATION_START_CSV_TABLE,
          DASHBOARD_TEMPLATE.COOPERATION_START_CSV_TEMPLATE_ID,
          searchConditions
        );
        return ('ok');
      }

      //RunCount取得後にCSV出力
      fn(searchItems).then(() => {
        // CSVファイル出力
        // ダッシュボード（マッチング）：課題登録件数CSV
        const agendaRegist_count = new Promise((resolve) => {
          tempfileName = DASHBOARD_CONSTANT.AGENDA_REGIST_CSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
          tempEndPoint = DASHBOARD_AGENDA_REGIST_CSV_USE_STATEMACHINE;
          tempTemplateId = DASHBOARD_TEMPLATE.AGENDA_REGIST_CSV_TEMPLATE_ID;
          tempTable = DASHBOARD_CONSTANT.AGENDA_REGIST_CSV_TABLE;
          stateMachineArn = DASHBOARD_AGENDA_REGIST_CSV_STATEMACHINEARN;
          RunCountRes = agendaRegist_rc;
          let searchItems1 = {
            ...searchItems,
            agenda_kbn: 1,
          };

          this.exportFileService.exportTemplateCsv_StepFunc(
            tempfileName,
            tempTable,
            tempEndPoint,
            tempTemplateId,
            DASHBOARD_READ_JSON_FROM_S3,
            stateMachineArn,
            RunCountRes,
            searchItems1,
            false,
            true
          ).subscribe(fileInformation => {
            filelist.push(fileInformation)
            resolve("ok")
          });
        })
        // ダッシュボード（マッチング）：ソリューション登録件数CSV
        const solutionRegist_count = new Promise((resolve) => {
          tempfileName = DASHBOARD_CONSTANT.SOLUTION_REGIST_CSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
          tempEndPoint = DASHBOARD_SOLUTION_REGIST_CSV_USE_STATEMACHINE;
          tempTemplateId = DASHBOARD_TEMPLATE.SOLUTION_REGIST_CSV_TEMPLATE_ID;
          tempTable = DASHBOARD_CONSTANT.SOLUTION_REGIST_CSV_TABLE;
          stateMachineArn = DASHBOARD_SOLUTION_REGIST_CSV_STATEMACHINEARN;
          RunCountRes = solutionRegist_rc;
          let searchItems2 = {
            ...searchItems,
            agenda_kbn: 2,
          };

          this.exportFileService.exportTemplateCsv_StepFunc(
            tempfileName,
            tempTable,
            tempEndPoint,
            tempTemplateId,
            DASHBOARD_READ_JSON_FROM_S3,
            stateMachineArn,
            RunCountRes,
            searchItems2,
            false,
            true
          ).subscribe(fileInformation => {
            filelist.push(fileInformation);
            resolve("ok");
          });
        })
        // ダッシュボード（マッチング）：提案登録件数CSV
        const suggestRegist_count = new Promise((resolve) => {
          tempfileName = DASHBOARD_CONSTANT.SUGGEST_REGIST_CSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
          tempEndPoint = DASHBOARD_SUGGEST_REGIST_CSV_USE_STATEMACHINE;
          tempTemplateId = DASHBOARD_TEMPLATE.SUGGEST_REGIST_CSV_TEMPLATE_ID;
          tempTable = DASHBOARD_CONSTANT.SUGGEST_REGIST_CSV_TABLE;
          stateMachineArn = DASHBOARD_SUGGEST_REGIST_CSV_STATEMACHINEARN;
          RunCountRes = suggestRegist_rc;

          this.exportFileService.exportTemplateCsv_StepFunc(
            tempfileName,
            tempTable,
            tempEndPoint,
            tempTemplateId,
            DASHBOARD_READ_JSON_FROM_S3,
            stateMachineArn,
            RunCountRes,
            searchItems,
            false,
            true
          ).subscribe(fileInformation => {
            filelist.push(fileInformation)
            resolve("ok")
          });
        })
        // ダッシュボード（マッチング）：意見交換希望件数CSV
        const opinionExchange_count = new Promise((resolve) => {
          tempfileName = DASHBOARD_CONSTANT.OPINION_EXCHANGE_CSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
          tempEndPoint = DASHBOARD_OPINION_EXCHANGE_CSV_USE_STATEMACHINE;
          tempTemplateId = DASHBOARD_TEMPLATE.OPINION_EXCHANGE_CSV_TEMPLATE_ID;
          tempTable = DASHBOARD_CONSTANT.OPINION_EXCHANGE_CSV_TABLE;
          stateMachineArn = DASHBOARD_OPINION_EXCHANGE_CSV_STATEMACHINEARN;
          RunCountRes = opinionExchange_rc;

          this.exportFileService.exportTemplateCsv_StepFunc(
            tempfileName,
            tempTable,
            tempEndPoint,
            tempTemplateId,
            DASHBOARD_READ_JSON_FROM_S3,
            stateMachineArn,
            RunCountRes,
            searchItems,
            false,
            true
          ).subscribe(fileInformation => {
            filelist.push(fileInformation)
            resolve("ok")
          });
        })
        // ダッシュボード（マッチング）：連携開始件数CSV
        const cooperation_start_count = new Promise((resolve) => {
          tempfileName = DASHBOARD_CONSTANT.COOPERATION_START_CSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
          tempEndPoint = DASHBOARD_COOPERATION_START_CSV_USE_STATEMACHINE;
          tempTemplateId = DASHBOARD_TEMPLATE.COOPERATION_START_CSV_TEMPLATE_ID;
          tempTable = DASHBOARD_CONSTANT.COOPERATION_START_CSV_TABLE;
          stateMachineArn = DASHBOARD_COOPERATION_START_CSV_STATEMACHINEARN;
          RunCountRes = cooperation_start_rc;

          this.exportFileService.exportTemplateCsv_StepFunc(
            tempfileName,
            tempTable,
            tempEndPoint,
            tempTemplateId,
            DASHBOARD_READ_JSON_FROM_S3,
            stateMachineArn,
            RunCountRes,
            searchItems,
            false,
            true
          ).subscribe(fileInformation => {
            filelist.push(fileInformation)
            resolve("ok")
          });
        })
        //全てのCSV生成後ZIP化
        Promise.all([
          agendaRegist_count,
          solutionRegist_count,
          suggestRegist_count,
          opinionExchange_count,
          cooperation_start_count
        ]).then(
          () => {
            this.exportFileService.zipFileDownload(
              fileName,
              ...filelist
            );
            // 画面ロードフラグをOFF(ロード終了)
            this.loadingState.loadSleepEnd(0.3, DASHBOARD_AGENDA_SOLUTION_2);
          }
        )
      });

    }
  }
  /**
   * 集計CSV ZIP出力
   * 引数　0=会員分析, 1=マッチングボトルネック分析
   */
  public exportZIP_totalCSV(flag: Number) {

    // csvファイル名の設定
    let fileName: string = "";
    if (flag === 0) {
      // 画面ロードフラグをON(ロード中状態)
      this.loadingState.loadStart(DASHBOARD_MEMBER_SUMCSV);
      fileName = DASHBOARD_CONSTANT.MEMBER_SUMMARY_TOTAL_ZIP_FILENAME;
    }
    else if (flag === 1) {
      // 画面ロードフラグをON(ロード中状態)
      this.loadingState.loadStart(DASHBOARD_AGENDA_REGIST_SUMCSV);
      fileName = DASHBOARD_CONSTANT.MATCHING_SUMMARY_TOTAL_ZIP_FILENAME;
    }

    //ファイル情報のリスト
    let filelist: Array<fileInformation> = []

    // 出力範囲を指定
    let searchItems = {
      summary_date_FROM: this.i101SearchFormMember.get('date1').value,
      summary_date_TO: this.i101SearchFormMember.get('date2').value,
    };
    // ファイル名、templateIdの振り分け
    let tempfileName, tempTemplateId, tempEndPoint, tempTable;
    // CSVファイル出力
    if (flag === 0) {
      // ダッシュボード（会員）：会員数の集計CSV
      const member_total = new Promise((resolve) => {
        tempfileName = DASHBOARD_CONSTANT.MEMBER_COUNT_SUMCSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
        tempEndPoint = DASHBOARD_MEMBER_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.MEMBER_COUNT_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.MEMBER_COUNT_SUMCSV_TABLE;

        this.exportFileService.exportTemplateCsv(
          tempfileName,
          tempTable,
          tempEndPoint,
          tempTemplateId,
          searchItems,
          false,
          true
        ).subscribe(fileInformation => {
          filelist.push(fileInformation)
          resolve("ok")
        });
      })
      // ダッシュボード（会員）：ID/PWD設定済U団体数の集計CSV
      const pwdSettingCompleteU_total = new Promise((resolve) => {
        tempfileName = DASHBOARD_CONSTANT.PWD_SETTING_U_SUMCSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
        tempEndPoint = DASHBOARD_PWD_SETTING_U_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.PWD_SETTING_U_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.PWD_SETTING_U_SUMCSV_TABLE;

        this.exportFileService.exportTemplateCsv(
          tempfileName,
          tempTable,
          tempEndPoint,
          tempTemplateId,
          searchItems,
          false,
          true
        ).subscribe(fileInformation => {
          filelist.push(fileInformation)
          resolve("ok")
        });
      })
      // ダッシュボード（会員）：ID/PWD設定済UU数の集計CSV
      const pwdSettingCompleteUU_total = new Promise((resolve) => {
        tempfileName = DASHBOARD_CONSTANT.PWD_SETTING_UU_SUMCSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
        tempEndPoint = DASHBOARD_PWD_SETTING_UU_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.PWD_SETTING_UU_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.PWD_SETTING_UU_SUMCSV_TABLE;

        this.exportFileService.exportTemplateCsv(
          tempfileName,
          tempTable,
          tempEndPoint,
          tempTemplateId,
          searchItems,
          false,
          true
        ).subscribe(fileInformation => {
          filelist.push(fileInformation)
          resolve("ok")
        });
      })
      // ダッシュボード（会員）：月間ログインU団体数の集計CSV
      const monthLoginOrganizationU_total = new Promise((resolve) => {
        tempfileName = DASHBOARD_CONSTANT.MONTH_LOGIN_U_SUMCSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
        tempEndPoint = DASHBOARD_MONTH_LOGIN_U_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.MONTH_LOGIN_U_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.MONTH_LOGIN_U_SUMCSV_TABLE;

        this.exportFileService.exportTemplateCsv(
          tempfileName,
          tempTable,
          tempEndPoint,
          tempTemplateId,
          searchItems,
          false,
          true
        ).subscribe(fileInformation => {
          filelist.push(fileInformation)
          resolve("ok")
        });
      })
      // ダッシュボード（会員）：月間ログインUU数の集計CSV
      const monthLoginOrganizationUU_total = new Promise((resolve) => {
        tempfileName = DASHBOARD_CONSTANT.MONTH_LOGIN_UU_SUMCSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
        tempEndPoint = DASHBOARD_MONTH_LOGIN_UU_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.MONTH_LOGIN_UU_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.MONTH_LOGIN_UU_SUMCSV_TABLE;

        this.exportFileService.exportTemplateCsv(
          tempfileName,
          tempTable,
          tempEndPoint,
          tempTemplateId,
          searchItems,
          false,
          true
        ).subscribe(fileInformation => {
          filelist.push(fileInformation)
          resolve("ok")
        });
      })
      // ダッシュボード（会員）：課題登録団体数（累計）の集計CSV
      const agendaRegistOrganization_total = new Promise((resolve) => {
        tempfileName = DASHBOARD_CONSTANT.AGENDA_REGIST_ORGANIZATION_SUMCSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
        tempEndPoint = DASHBOARD_AGENDA_REGIST_ORGANIZATION_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.AGENDA_REGIST_ORGANIZATION_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.AGENDA_REGIST_ORGANIZATION_SUMCSV_TABLE;

        this.exportFileService.exportTemplateCsv(
          tempfileName,
          tempTable,
          tempEndPoint,
          tempTemplateId,
          searchItems,
          false,
          true
        ).subscribe(fileInformation => {
          filelist.push(fileInformation)
          resolve("ok")
        });
      })

      //全てのCSV生成後ZIP化
      Promise.all([
        member_total,
        pwdSettingCompleteU_total,
        pwdSettingCompleteUU_total,
        monthLoginOrganizationU_total,
        monthLoginOrganizationUU_total,
        agendaRegistOrganization_total
      ]).then(
        () => {
          this.exportFileService.zipFileDownload(
            fileName,
            ...filelist
          );
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, DASHBOARD_MEMBER_SUMCSV);

        }
      )
    }
    else if (flag === 1) {
      // ダッシュボード（マッチング）：課題登録件数集計CSV
      const agendaRegist_total = new Promise((resolve) => {
        tempfileName = DASHBOARD_CONSTANT.AGENDA_REGIST_SUMCSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
        tempEndPoint = DASHBOARD_AGENDA_REGIST_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.AGENDA_REGIST_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.AGENDA_REGIST_SUMCSV_TABLE;

        this.exportFileService.exportTemplateCsv(
          tempfileName,
          tempTable,
          tempEndPoint,
          tempTemplateId,
          searchItems,
          false,
          true
        ).subscribe(fileInformation => {
          filelist.push(fileInformation)
          resolve("ok")
        });
      })
      // ダッシュボード（マッチング）：ソリューション登録件数集計CSV
      const solutionRegist_total = new Promise((resolve) => {
        tempfileName = DASHBOARD_CONSTANT.SOLUTION_REGIST_SUMCSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
        tempEndPoint = DASHBOARD_SOLUTION_REGIST_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.SOLUTION_REGIST_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.SOLUTION_REGIST_SUMCSV_TABLE;

        this.exportFileService.exportTemplateCsv(
          tempfileName,
          tempTable,
          tempEndPoint,
          tempTemplateId,
          searchItems,
          false,
          true
        ).subscribe(fileInformation => {
          filelist.push(fileInformation)
          resolve("ok")
        });
      })
      // ダッシュボード（マッチング）：提案登録件数集計CSV
      const suggestRegist_total = new Promise((resolve) => {
        tempfileName = DASHBOARD_CONSTANT.SUGGEST_REGIST_SUMCSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
        tempEndPoint = DASHBOARD_SUGGEST_REGIST_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.SUGGEST_REGIST_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.SUGGEST_REGIST_SUMCSV_TABLE;

        this.exportFileService.exportTemplateCsv(
          tempfileName,
          tempTable,
          tempEndPoint,
          tempTemplateId,
          searchItems,
          false,
          true
        ).subscribe(fileInformation => {
          filelist.push(fileInformation)
          resolve("ok")
        });
      })
      // ダッシュボード（マッチング）：意見交換希望件数集計CSV
      const opinionExchange_total = new Promise((resolve) => {
        tempfileName = DASHBOARD_CONSTANT.OPINION_EXCHANGE_SUMCSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
        tempEndPoint = DASHBOARD_OPINION_EXCHANGE_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.OPINION_EXCHANGE_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.OPINION_EXCHANGE_SUMCSV_TABLE;

        this.exportFileService.exportTemplateCsv(
          tempfileName,
          tempTable,
          tempEndPoint,
          tempTemplateId,
          searchItems,
          false,
          true
        ).subscribe(fileInformation => {
          filelist.push(fileInformation)
          resolve("ok")
        });
      })
      // ダッシュボード（マッチング）：連携開始件数集計CSV
      const cooperation_start_total = new Promise((resolve) => {
        tempfileName = DASHBOARD_CONSTANT.COOPERATION_START_SUMCSV_FILENAME + CONSTANT.UNDERBAR + this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);
        tempEndPoint = DASHBOARD_COOPERATION_START_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.COOPERATION_START_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.COOPERATION_START_SUMCSV_TABLE;

        this.exportFileService.exportTemplateCsv(
          tempfileName,
          tempTable,
          tempEndPoint,
          tempTemplateId,
          searchItems,
          false,
          true
        ).subscribe(fileInformation => {
          filelist.push(fileInformation)
          resolve("ok")
        });
      })
      //全てのCSV生成後ZIP化
      Promise.all([
        agendaRegist_total,
        solutionRegist_total,
        suggestRegist_total,
        opinionExchange_total,
        cooperation_start_total
      ]).then(
        () => {
          this.exportFileService.zipFileDownload(
            fileName,
            ...filelist
          );
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, DASHBOARD_AGENDA_REGIST_SUMCSV);
        }
      )

    }
  }

  /**
   * 個別CSV出力_(ダッシュボード明細系はの除く)
   */
  public exportCSV(type?: string) {
    // 出力範囲を指定
    let searchItems = {
      summary_date_FROM: this.i101SearchFormMember.get('date1').value,
      summary_date_TO: this.i101SearchFormMember.get('date2').value,
    };

    let tempfileName, tempTemplateId, tempEndPoint, tempTable;
    switch (type) {
      //集計系
      case "member_total":
        // ダッシュボード(会員：会員数の集計) の場合
        tempfileName = DASHBOARD_CONSTANT.MEMBER_COUNT_SUMCSV_FILENAME;
        tempEndPoint = DASHBOARD_MEMBER_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.MEMBER_COUNT_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.MEMBER_COUNT_SUMCSV_TABLE;
        break;
      case "pwdSettingCompleteU_total":
        // ダッシュボード(会員：ID/PWD設定済U団体数の集計) の場合
        tempfileName = DASHBOARD_CONSTANT.PWD_SETTING_U_SUMCSV_FILENAME;
        tempEndPoint = DASHBOARD_PWD_SETTING_U_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.PWD_SETTING_U_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.PWD_SETTING_U_SUMCSV_TABLE;
        break;
      case "pwdSettingCompleteUU_total":
        // ダッシュボード(会員：ID/PWD設定済UU数の集計) の場合
        tempfileName = DASHBOARD_CONSTANT.PWD_SETTING_UU_SUMCSV_FILENAME;
        tempEndPoint = DASHBOARD_PWD_SETTING_UU_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.PWD_SETTING_UU_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.PWD_SETTING_UU_SUMCSV_TABLE;
        break;
      case "monthLoginOrganizationU_total":
        // ダッシュボード(会員：月間ログインU団体数の集計) の場合
        tempfileName = DASHBOARD_CONSTANT.MONTH_LOGIN_U_SUMCSV_FILENAME;
        tempEndPoint = DASHBOARD_MONTH_LOGIN_U_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.MONTH_LOGIN_U_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.MONTH_LOGIN_U_SUMCSV_TABLE;
        break;
      case "monthLoginOrganizationUU_total":
        // ダッシュボード(会員：月間ログインUU数の集計) の場合
        tempfileName = DASHBOARD_CONSTANT.MONTH_LOGIN_UU_SUMCSV_FILENAME;
        tempEndPoint = DASHBOARD_MONTH_LOGIN_UU_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.MONTH_LOGIN_UU_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.MONTH_LOGIN_UU_SUMCSV_TABLE;
        break;
      case "agendaRegistOrganization_total":
        // ダッシュボード(会員：課題登録団体数（累計）の集計) の場合
        tempfileName = DASHBOARD_CONSTANT.AGENDA_REGIST_ORGANIZATION_SUMCSV_FILENAME;
        tempEndPoint = DASHBOARD_AGENDA_REGIST_ORGANIZATION_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.AGENDA_REGIST_ORGANIZATION_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.AGENDA_REGIST_ORGANIZATION_SUMCSV_TABLE;
        break;
      case "agendaRegist_total":
        // ダッシュボード(マッチング：課題登録件数の集計) の場合
        tempfileName = DASHBOARD_CONSTANT.AGENDA_REGIST_SUMCSV_FILENAME;
        tempEndPoint = DASHBOARD_AGENDA_REGIST_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.AGENDA_REGIST_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.AGENDA_REGIST_SUMCSV_TABLE;
        break;
      case "solutionRegist_total":
        // ダッシュボード(マッチング：ソリューション登録件数の集計) の場合
        tempfileName = DASHBOARD_CONSTANT.SOLUTION_REGIST_SUMCSV_FILENAME;
        tempEndPoint = DASHBOARD_SOLUTION_REGIST_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.SOLUTION_REGIST_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.SOLUTION_REGIST_SUMCSV_TABLE;
        break;
      case "suggestRegist_total":
        // ダッシュボード(マッチング：提案登録件数の集計) の場合
        tempfileName = DASHBOARD_CONSTANT.SUGGEST_REGIST_SUMCSV_FILENAME;
        tempEndPoint = DASHBOARD_SUGGEST_REGIST_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.SUGGEST_REGIST_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.SUGGEST_REGIST_SUMCSV_TABLE;
        break;
      case "opinionExchange_total":
        // ダッシュボード(マッチング：意見交換希望件数) の場合
        tempfileName = DASHBOARD_CONSTANT.OPINION_EXCHANGE_SUMCSV_FILENAME;
        tempEndPoint = DASHBOARD_OPINION_EXCHANGE_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.OPINION_EXCHANGE_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.OPINION_EXCHANGE_SUMCSV_TABLE;
        break;
      case "cooperation_start_total":
        // ダッシュボード(マッチング：連携開始件数) の場合
        tempfileName = DASHBOARD_CONSTANT.COOPERATION_START_SUMCSV_FILENAME;
        tempEndPoint = DASHBOARD_COOPERATION_START_SUMCSV;
        tempTemplateId = DASHBOARD_TEMPLATE.COOPERATION_START_SUMCSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.COOPERATION_START_SUMCSV_TABLE;
        break;
      default:
        break;
    }
    // csvファイル名の設定
    const fileName =
      tempfileName +
      CONSTANT.UNDERBAR +
      this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);

    // CSVファイル出力
    this.exportFileService.exportTemplateCsv(
      fileName,
      tempTable,
      tempEndPoint,
      tempTemplateId,
      searchItems,
    );
  }

  /**
   * 個別CSV出力_ダッシュボード明細系
   * 明細系は出力に時間がかかるものが多いため、StepFunctionsを使用したCSV出力を行う
   */
  public exportCSV_STATEMACHINE(type?: string) {
    // 出力範囲を指定
    let searchItems = {
      summary_date_FROM: this.i101SearchFormMember.get('date1').value,
      summary_date_TO: this.i101SearchFormMember.get('date2').value,
    };

    let tempfileName, tempTemplateId, tempEndPoint, tempTable, stateMachineArn;

    switch (type) {
      case "member_count":
        // ダッシュボード(会員：会員数) の場合
        tempfileName = DASHBOARD_CONSTANT.MEMBER_COUNT_CSV_FILENAME;
        tempEndPoint = DASHBOARD_MEMBER_CSV_USE_STATEMACHINE;
        tempTemplateId = DASHBOARD_TEMPLATE.MEMBER_COUNT_CSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.MEMBER_COUNT_CSV_TABLE;
        stateMachineArn = DASHBOARD_MEMBER_CSV_STATEMACHINEARN;

        break;
      case "pwdSettingCompleteU_count":
        // ダッシュボード(会員：ID/PWD設定済U団体数) の場合
        tempfileName = DASHBOARD_CONSTANT.PWD_SETTING_U_CSV_FILENAME;
        tempEndPoint = DASHBOARD_PWD_SETTING_U_CSV_USE_STATEMACHINE;
        tempTemplateId = DASHBOARD_TEMPLATE.PWD_SETTING_U_CSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.PWD_SETTING_U_CSV_TABLE;
        stateMachineArn = DASHBOARD_PWD_SETTING_U_CSV_STATEMACHINE;

        break;
      case "pwdSettingCompleteUU_count":
        // ダッシュボード(会員：ID/PWD設定済UU数) の場合
        tempfileName = DASHBOARD_CONSTANT.PWD_SETTING_UU_CSV_FILENAME;
        tempEndPoint = DASHBOARD_PWD_SETTING_UU_CSV_USE_STATEMACHINE;
        tempTemplateId = DASHBOARD_TEMPLATE.PWD_SETTING_UU_CSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.PWD_SETTING_UU_CSV_TABLE;
        stateMachineArn = DASHBOARD_PWD_SETTING_UU_CSV_STATEMACHINE;

        break;
      case "monthLoginOrganizationU_count":
        // ダッシュボード(会員：月間ログインU団体数) の場合
        tempfileName = DASHBOARD_CONSTANT.MONTH_LOGIN_U_CSV_FILENAME;
        tempEndPoint = DASHBOARD_MONTH_LOGIN_U_CSV_USE_STATEMACHINE;
        tempTemplateId = DASHBOARD_TEMPLATE.MONTH_LOGIN_U_CSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.MONTH_LOGIN_U_CSV_TABLE;
        stateMachineArn = DASHBOARD_MONTH_LOGIN_U_CSV_STATEMACHINE;

        break;
      case "monthLoginOrganizationUU_count":
        // ダッシュボード(会員：月間ログインUU数) の場合
        tempfileName = DASHBOARD_CONSTANT.MONTH_LOGIN_UU_CSV_FILENAME;
        tempEndPoint = DASHBOARD_MONTH_LOGIN_UU_CSV_USE_STATEMACHINE;
        tempTemplateId = DASHBOARD_TEMPLATE.MONTH_LOGIN_UU_CSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.MONTH_LOGIN_UU_CSV_TABLE;
        stateMachineArn = DASHBOARD_MONTH_LOGIN_UU_CSV_STATEMACHINE;

        break;
      case "agendaRegistOrganization_count":
        // ダッシュボード(会員：課題登録団体数（累計）) の場合
        tempfileName = DASHBOARD_CONSTANT.AGENDA_REGIST_ORGANIZATION_CSV_FILENAME;
        tempEndPoint = DASHBOARD_AGENDA_REGIST_ORGANIZATION_CSV_USE_STATEMACHINE;
        tempTemplateId = DASHBOARD_TEMPLATE.AGENDA_REGIST_ORGANIZATION_CSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.AGENDA_REGIST_ORGANIZATION_CSV_TABLE;
        stateMachineArn = DASHBOARD_AGENDA_REGIST_ORGANIZATION_CSV_STATEMACHINE;

        break;
      case "agendaRegist_count":
        // ダッシュボード(マッチング：課題登録件数) の場合
        tempfileName = DASHBOARD_CONSTANT.AGENDA_REGIST_CSV_FILENAME;
        tempEndPoint = DASHBOARD_AGENDA_REGIST_CSV_USE_STATEMACHINE;
        tempTemplateId = DASHBOARD_TEMPLATE.AGENDA_REGIST_CSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.AGENDA_REGIST_CSV_TABLE;
        stateMachineArn = DASHBOARD_AGENDA_REGIST_CSV_STATEMACHINEARN;
        searchItems["agenda_kbn"] = 1;
        
        break;
      case "solutionRegist_count":
        // ダッシュボード(マッチング：ソリューション登録件数) の場合
        tempfileName = DASHBOARD_CONSTANT.SOLUTION_REGIST_CSV_FILENAME;
        tempEndPoint = DASHBOARD_SOLUTION_REGIST_CSV_USE_STATEMACHINE;
        tempTemplateId = DASHBOARD_TEMPLATE.SOLUTION_REGIST_CSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.SOLUTION_REGIST_CSV_TABLE;
        searchItems["agenda_kbn"] = 2;
        stateMachineArn = DASHBOARD_SOLUTION_REGIST_CSV_STATEMACHINEARN;
        
        break;
      case "suggestRegist_count":
        // ダッシュボード(マッチング：提案登録件数) の場合
        tempfileName = DASHBOARD_CONSTANT.SUGGEST_REGIST_CSV_FILENAME;
        tempEndPoint = DASHBOARD_SUGGEST_REGIST_CSV_USE_STATEMACHINE;
        tempTemplateId = DASHBOARD_TEMPLATE.SUGGEST_REGIST_CSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.SUGGEST_REGIST_CSV_TABLE;
        stateMachineArn = DASHBOARD_SUGGEST_REGIST_CSV_STATEMACHINEARN;
        
        break;
      case "opinionExchange_count":
        // ダッシュボード(マッチング：意見交換希望件数) の場合
        tempfileName = DASHBOARD_CONSTANT.OPINION_EXCHANGE_CSV_FILENAME;
        tempEndPoint = DASHBOARD_OPINION_EXCHANGE_CSV_USE_STATEMACHINE;
        tempTemplateId = DASHBOARD_TEMPLATE.OPINION_EXCHANGE_CSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.OPINION_EXCHANGE_CSV_TABLE;
        stateMachineArn = DASHBOARD_OPINION_EXCHANGE_CSV_STATEMACHINEARN;

        break;
      case "cooperation_start_count":
        // ダッシュボード(マッチング：連携開始件数) の場合
        tempfileName = DASHBOARD_CONSTANT.COOPERATION_START_CSV_FILENAME;
        tempEndPoint = DASHBOARD_COOPERATION_START_CSV_USE_STATEMACHINE;
        tempTemplateId = DASHBOARD_TEMPLATE.COOPERATION_START_CSV_TEMPLATE_ID;
        tempTable = DASHBOARD_CONSTANT.COOPERATION_START_CSV_TABLE;
        stateMachineArn = DASHBOARD_COOPERATION_START_CSV_STATEMACHINEARN;
        
        break;
      default:
        break;
    }
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(tempEndPoint);

    // csvファイル名の設定
    const fileName =
      tempfileName +
      CONSTANT.UNDERBAR +
      this.datePipe.transform(new Date(), DATE_FORMAT.DATETIME_HYPHEN);

    //RunCount取得
    const get_runCount = (
      tempTable,
      tempTemplateId,
      searchItems
    ) => {
      return new Promise<HttpResponse<any>>((resolve) => {
        this.dbOperationService
          .getRunCount(
            tempTable,
            tempTemplateId,
            searchItems
          ).subscribe((value) => {
            resolve(value);
          })
      });
    }
    //CSVの出力
    const get_csv = (
      runCount
    ) => {
      return new Promise<string>((resolve) => {
        // CSVファイル出力
        this.exportFileService.exportTemplateCsv_StepFunc(
          fileName,
          tempTable,
          tempEndPoint,
          tempTemplateId,
          DASHBOARD_READ_JSON_FROM_S3,
          stateMachineArn,
          runCount,
          searchItems,
        ).subscribe(() => {
          //ファイル情報が返却されるが使用せず終了判定のみ
          resolve('ok');
        })
      });
    }

    //直列処理
    async function fn(table: string, templateId: number, searchConditions: any) {
      //RunCount取得まで待機
      const runcount: HttpResponse<any> = await get_runCount(table, templateId, searchConditions);
      //CSV取得まで待機
      const res: string = await get_csv(runcount);
      return res;
    }

    // CSVを取得したらロード終了
    fn(tempTable, tempTemplateId, searchItems).then(() => {
      this.loadingState.loadSleepEnd(0.3, tempEndPoint);
    });
  }

  /**
   * マイページ(B301)へ遷移する
   */
  public moveB301(): void {
    // マイページ(B301)へ遷移
    this.router.navigate(['pages/platform/b301']);
  }

  /**
   *事務局(D101)へ遷移する
   */
  public moveD101(): void {
    // 事務局(D101)へ遷移
    this.router.navigate(['pages/platform/d101']);
  }

  /**
   *詳細説明PDFへ遷移する
   */
  public moveInstructions(): void {
    // 詳細説明PDFへ遷移
    let newwin = window.open('pages/platform/b301/');
  }

  // ---------------------------------------------------------------------------- //
  // データ設定

  /**
   * 表示データ設定処理
   * @param dataList 格納する変数
   * @param chartType 'line' または 'bar'
   */
  public setChartData(dataList: any, chartType: string): any {
    // 表示データをdataListを元に生成
    // データ格納用
    let seriesValues = [[], [], [], []];//[[1号会員],[2号会員],[3号会員],[事務局]]
    let seriesLabels = new Array();
    let firstFlg = true;
    // 格納処理
    dataList.forEach(memberData => {
      let pushArray = new Array();
      switch (memberData["name"]) {
        case "1号会員":
          memberData["series"].forEach(element => {
            if (element.value !== undefined) {
              pushArray.push(element.value);
              if (firstFlg) seriesLabels.push(element.date);
            }
          });
          seriesValues.splice(0, 1, pushArray);
          break;
        case "2号会員":
          memberData["series"].forEach(element => {
            if (element.value !== undefined) {
              pushArray.push(element.value);
              if (firstFlg) seriesLabels.push(element.date);
            }
          });
          seriesValues.splice(1, 1, pushArray);
          break;
        case "3号会員":
          memberData["series"].forEach(element => {
            if (element.value !== undefined) {
              pushArray.push(element.value);
              if (firstFlg) seriesLabels.push(element.date);
            }
          });
          seriesValues.splice(2, 1, pushArray);
          break;
        case "事務局":
          memberData["series"].forEach(element => {
            if (element.value !== undefined) {
              pushArray.push(element.value);
              if (firstFlg) seriesLabels.push(element.date);
            }
          });
          seriesValues.splice(3, 1, pushArray);
          break;
      }

      if (pushArray.length != 0) {
        firstFlg = false;
      }
    });
    // 格納後、データが無い会員があれば0埋めの配列を格納
    seriesValues.forEach((e, index) => {
      if (e.length <= 0) {
        seriesValues.splice(index, 1, new Array<number>(seriesLabels.length).fill(0));
      }
    })

    if (chartType == 'line') {
      return {
        labels: seriesLabels,
        datasets: [{
          type: chartType,
          label: '1号会員',
          backgroundColor: '#3366FF',
          data: seriesValues[0],
          lineTension: 0,
          fill: 'origin',
          pointRadius: 5,
          pointHoverRadius: 8,
          pointHitRadius: 10,
        }, {
          type: chartType,
          label: '2号会員',
          backgroundColor: '#FF9966',
          data: seriesValues[1],
          lineTension: 0,
          fill: 0,
          pointRadius: 5,
          pointHoverRadius: 8,
          pointHitRadius: 10,
        }, {
          type: chartType,
          label: '3号会員',
          backgroundColor: '#66CC66',
          data: seriesValues[2],
          lineTension: 0,
          fill: 1,
          pointRadius: 5,
          pointHoverRadius: 8,
          pointHitRadius: 10,
        }]
      };
    } else {
      return {
        labels: seriesLabels,
        datasets: [{
          type: chartType,
          label: '1号会員',
          backgroundColor: '#3366FF',
          data: seriesValues[0],
          lineTension: 0,
          fill: 'origin',
        }, {
          type: chartType,
          label: '2号会員',
          backgroundColor: '#FF9966',
          data: seriesValues[1],
          lineTension: 0,
          fill: 0,
        }, {
          type: chartType,
          label: '3号会員',
          backgroundColor: '#66CC66',
          data: seriesValues[2],
          lineTension: 0,
          fill: 1,
        }]
      };
    }

  }

  /**
   * 表示データ設定処理
   * @param dataList 検索データ
   */
  public setChartComboData(dataList: any): any {
    // 表示データをdataListを元に生成
    // データ格納用
    let seriesValues = new Array();
    let seriesLabels = new Array();
    let firstFlg = true;
    // 格納処理
    dataList.forEach(comboData => {
      let pushArray = new Array();
      comboData["series"].forEach(element => {
        if (element.value !== undefined) {
          pushArray.push(element.value);
          if (firstFlg) seriesLabels.push(element.date);
        }
      });
      if (pushArray.length != 0) {
        seriesValues.push(pushArray);
        firstFlg = false;
      }
    });

    return {
      labels: seriesLabels,
      datasets: [
        {
          type: 'line',
          label: dataList[1]["name"],
          borderColor: '#666666',
          data: seriesValues[1],
          lineTension: 0,
          fill: false,
          pointRadius: 5,
          pointHoverRadius: 8,
          pointHitRadius: 10,
        },
        {
          type: 'bar',
          label: dataList[0]["name"],
          backgroundColor: '#3366FF',
          data: seriesValues[0],
          lineTension: 0,
          fill: true,
        }
      ]
    };
  }

  /**
   * 検索条件のクリア
   */
  public clearConditions(): void {
    this.initParamSetting();
  }

  /**
   * 検索条件の保存
   */
  private saveConditions(): void {
    //[日付条件_FROM],[日付条件_TO]　で記録
    let s = this.i101SearchFormMember.get('date1').value + "," + this.i101SearchFormMember.get('date2').value;
    sessionStorage.setItem(this.sessionTagName, s)
  }

}
function fromDate(fromDate: any) {
  throw new Error('Function not implemented.');
}

